/* eslint-disable no-nested-ternary */
import React from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../store';
import { useActions } from '../../providers/actions-provider/actions.context';
import { REPORTS_LIST_PATH } from '../../routing/paths.constants';
import { IThirdStep } from './interfaces';
import './create-report.less';
import ReportParams from '../edit-report/report-params';
import checkPermission from '../../../utils/permissions/permissions';

const ThirdStepFilters = ({
  stepHandler,
  formikForFirstStep,
  formikForSecondStep,
  regex,
  quickRanges,
  operators,
  filterFields,
}: IThirdStep): JSX.Element => {
  // to hook + memo
  const { reportActions } = useActions();
  const { currentUser } = useStore();
  const { location: { pathname }, push } = useHistory();
  const { values: firstStepValues } = formikForFirstStep;
  const { values: secondStepValues } = formikForSecondStep;

  // prepare finally body for creation
  function bodyForRequest(find: string, sort: string) {
    return {
      reportGroup_id: firstStepValues.reportGroup_id,
      name: firstStepValues.name,
      code: firstStepValues.code,
      tenant: currentUser.data.tenant,
      collection: firstStepValues.collection,
      find: find || '',
      aggregate: firstStepValues.aggregate,
      sort: sort || '',
    };
  }
  // final behavior before creation
  async function finalHandler(filtersString: string, sortsString: string) {
    const body = bodyForRequest(filtersString, sortsString);
    await reportActions.createReport(body, secondStepValues.fieldsTable);

    if (pathname.lastIndexOf('/') !== 13) {
      reportActions.getReportsList();
      push(`${REPORTS_LIST_PATH}${pathname.slice(pathname.indexOf('/', 14))}`);
    } else {
      reportActions.getReportsList();
      push(REPORTS_LIST_PATH);
    }
  }

  return (
    <ReportParams
      regex={regex}
      notEditable={!checkPermission('reports', 'write')}
      quickRanges={quickRanges}
      operators={operators}
      filterFields={filterFields}
      submitButtonLabel="create report"
      onSubmitAction={finalHandler}
      filtersString=""
      sortsString=""
      reportColumns={secondStepValues.fieldsTable}
      reportCollection={formikForFirstStep.values.collection}
      submitButtonAlwaysEnabled
      renderAdditionalButtons={() => (
        <span style={{ display: 'inline-block', paddingRight: '8px' }}>
          <Button
            htmlType="reset"
            type="default"
            style={{ width: 280 }}
            className="fields-table__button-cancel"
            // disabled={editField !== 0}
            onClick={() => {
              stepHandler(1);
            }}
          >
            back
          </Button>
        </span>
      )}
    />
  );
};

ThirdStepFilters.displayName = 'ThirdStepFilters';
export default ThirdStepFilters;
